<template>
  <div class="body1">
    <div class="content">
      <img class="img" src="../../assets/eblock-02.png">
      <div class="title">
        E-Blocks English is a multi-award winning program for<br/> children. All students, including English language <br/>learners and special needs children, benefit from <br/>hands-on approach to language learning.
      </div>
    </div>
    <div class="content">
      <div class="title">
        E-Blocks consolidates students’ reading skills and<br/> understanding of culture through meaningful and<br/> enjoyable activities, games, fables, proverbs and <br/>sayings, tongue twisters, animations and videos.
      </div>
      <img class="img" src="../../assets/eblock-03.png">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 773px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .content{
    .media-content;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .title{
      text-align: left;
      color: #666666;
      font-size: 18px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      line-height: 30px;
    }
    .img{
      width: 487px;
      object-fit: contain;
      height: 322px;
      margin: 0 26px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/eblocks/e-body2.vue